/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Sign_Email_InvalidInputs */

const en_common_sign_email_invalid = /** @type {(inputs: Common_Sign_Email_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a valid email address`)
};

const zh_common_sign_email_invalid = /** @type {(inputs: Common_Sign_Email_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请输入有效的邮箱地址`)
};

/**
* | output |
* | --- |
* | "Enter a valid email address" |
*
* @param {Common_Sign_Email_InvalidInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_sign_email_invalid = /** @type {((inputs?: Common_Sign_Email_InvalidInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Sign_Email_InvalidInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_sign_email_invalid(inputs)
	return zh_common_sign_email_invalid(inputs)
});
export { common_sign_email_invalid as "common.sign.email_invalid" }